import React from "react";
import { object, array, func, string } from "prop-types";

import { getUserMetaData } from "../../utils/utils";
import { makeJuspayPayment } from "../../helper/access-type";
import { setCookie } from "../../helper/cookies";

import "./otherPaymentsView.m.css";

const OtherPaymentsView = ({
  plan,
  plans,
  otherPaymentOptions,
  member,
  sucessCallback,
  failureCallback,
  closePopup,
  currentPath,
}) => {
  const triggerPaymentgetwayGA = (name) => {
    window.dataLayer.push({
      event: "payment_gateway",
      payment_gateway_Name: name,
    });
  };

  const handlePayTmPayment = (e) => {
    e.preventDefault();
    triggerPaymentgetwayGA("Paytm");

    document.paytm.submit();
  };

  const handleJuspayPayment = () => {
    triggerPaymentgetwayGA("Juspay");
    closePopup();
    makeJuspayPayment(plan, otherPaymentOptions).then(sucessCallback).catch(failureCallback);
  };

  const paytmView = () => {
    const zeroValuePlans = plans.filter((plan) => plan.price_cents === 0);
    let paytmPlan;

    if (currentPath === "/independence-day-membership") {
      paytmPlan = zeroValuePlans.find((i) => i.title.includes(plan.title));
    } else {
      paytmPlan = zeroValuePlans.find(
        (i) => i.duration_length === plan.duration_length && i.duration_unit === plan.duration_unit
      );
    }

    if (!(paytmPlan && paytmPlan.id)) {
      throw new Error("Paytm plan not found. Please contact support");
    }
    setCookie("paytmId", `${paytmPlan.id}`, 600);

    const userDataObj = getUserMetaData(member);

    return (
      <form action="/paytm/gen-checksum" method="post" name="paytm">
        <input type="hidden" name="user_id" value={member.id} />
        <input type="hidden" name="amount" value={`${String(plan.price_cents / 100)}`} />
        <input type="hidden" name="mobile" value={`${userDataObj.mobileNumber || ""}`} />
        <input type="hidden" name="name" value={`${member.name || ""}`} />
        <input type="hidden" name="email" value={member.email} />
      </form>
    );
  };

  return (
    <div styleName="wrapper">
      <span styleName="title">Select payment gateway</span>

      <div styleName="content">
        <button styleName="button" onClick={handlePayTmPayment}>
          <img
            styleName="img-view"
            src="https://fea.assettype.com/thequint/assets/payment-related-logos/paytm-logo-6be8af4af6.png"
            alt="paytm"
          />
        </button>

        <span styleName="or">or</span>
        <button styleName="button" onClick={handleJuspayPayment}>
          <img
            styleName="img-view"
            src="https://fea.assettype.com/thequint/assets/payment-related-logos/juspay-logo-290e8e167d.png"
            alt="justpay"
          />
        </button>
      </div>

      {paytmView()}
    </div>
  );
};

OtherPaymentsView.propTypes = {
  member: object,
  plan: object,
  plans: array,
  otherPaymentOptions: object,
  closePopup: func,
  sucessCallback: func,
  failureCallback: func,
  currentPath: string,
};

export default OtherPaymentsView;
